export default {
  data () {
    return {
      dModuleConfig: this.$danmaku.module.getModuleConfig(this.$options.config || this.$options.moduleConfig),
      dModuleData: this.$danmaku.module.getModuleData(this.$options.moduleData)
    }
  },
  mounted () {
    if (this.$options.acceptModuleNames) {
      this.$danmaku.browserView.sendAcceptModuleNames(this.$options.acceptModuleNames)
    }
    let danmaku = this.$options.danmaku
    if (danmaku) {
      this._danmakuEventListeners = {}
      let emitters = ['module', 'platform', 'browserView']
      emitters.forEach(emitter => {
        if (danmaku[emitter]) {
          this._danmakuEventListeners[emitter] = {}
          Object.keys(danmaku[emitter]).forEach(event => {
            let func = danmaku[emitter][event].bind(this)
            this.$danmaku[emitter].on(event, func)
            this._danmakuEventListeners[emitter][event] = func
          })
        }
      })
    }
    this._danmakuUpdateModuleConfigEventListener = function (config) {
      this.dModuleConfig = config
    }.bind(this)
    this.$danmaku.module.on('updateModuleConfig', this._danmakuUpdateModuleConfigEventListener)

    this._danmakuUpdateModuleDataEventListener = function (data) {
      this.dModuleData = data
    }.bind(this)
    this.$danmaku.module.on('updateModuleData', this._danmakuUpdateModuleDataEventListener)
  },
  destroyed () {
    if (this._danmakuEventListeners) {
      Object.keys(this._danmakuEventListeners).forEach(emitter => {
        Object.keys(this._danmakuEventListeners[emitter]).forEach(event => {
          this.$danmaku[emitter].removeListener(event, this._danmakuEventListeners[emitter][event])
        })
      })
    }
    this.$danmaku.module.removeListener('updateModuleConfig', this._danmakuUpdateModuleConfigEventListener)
    this.$danmaku.module.removeListener('updateModuleData', this._danmakuUpdateModuleDataEventListener)
  }
}



// WEBPACK FOOTER //
// ./src/mixins/DanmakuModuleMixin.js